import { IconProps, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { HomeRepairService, RequestQuote, PermPhoneMsg, Store } from '@mui/icons-material';
import { hasPermission } from "../../services/AuthService";
import { getPermissionObjectNameById, PermissionObjectIds } from "../../models/enums/PermissionObjects";
import { UserActions } from "../../models/enums/UserActions";
import { useNavigate } from "react-router-dom";
import { useStyles } from "./SideNavBar";

class PermissionObjectInfo {
    Image?: React.ReactElement<IconProps>;
    Path: string = "/";
    Indent: boolean = true;
}

function SideBarItem(permissionId: PermissionObjectIds) {
	const classes = useStyles();
    const navigate = useNavigate();
    if (hasPermission(permissionId, UserActions["READ"]))
    {
        let name = getPermissionObjectNameById(permissionId);
        let info = getPermissionObjectInfo(permissionId);
        return(
            <ListItem button key={name} className={info.Indent ? classes.sideBarItemIndent : classes.sideBarItem } onClick={() => navigate(info.Path)}>
                <ListItemIcon>
                    {getPermissionObjectInfo(permissionId).Image}
                </ListItemIcon>
                <ListItemText primary={name} />
            </ListItem>
        );
    }
} 

function getPermissionObjectInfo(permissionId: PermissionObjectIds)
{
    let info: PermissionObjectInfo = new PermissionObjectInfo();
    switch(permissionId)
    {
        case PermissionObjectIds.QUOTATION:
            info.Image = <PermPhoneMsg fontSize="large" />;
            info.Path = "/app/quotation";
            info.Indent = false;
            break;
        case PermissionObjectIds.PURCHASE_ORDER:
            info.Image = <Store fontSize="large" />;
            info.Path = "/app/purchaseOrder";
            info.Indent = false;
            break;
        case PermissionObjectIds.INVOICE:
            info.Image = <RequestQuote fontSize="large" />;
            info.Path = "/app/invoice"; 
            info.Indent = false;
            break;
        case PermissionObjectIds.PACKING_LIST:
            info.Image = <HomeRepairService fontSize="large" />;
            info.Path = "/app/packingList"; 
            info.Indent = false;
            break;
        case PermissionObjectIds.BANK_ACCOUNT:
            info.Path = "/app/bankAccounts"; 
            info.Indent = true;
            break;
        case PermissionObjectIds.BRANCH_SETUP:
            info.Path = "/app/branches"; 
            info.Indent = true;
            break;            
        case PermissionObjectIds.ACCOUNT_STATEMENT_RECORD:
            info.Path = "/app/statementRecords"; 
            info.Indent = true;
            break;
        case PermissionObjectIds.ACCOUNT_STATEMENT:
            info.Path = "/app/statements"; 
            info.Indent = true;
            break;            
        case PermissionObjectIds.EXCHANGE_RATE:
            info.Path = "/app/exchangeRates"; 
            info.Indent = true;
            break;          
        case PermissionObjectIds.CUSTOMER:
            info.Path = "/app/customers"; 
            info.Indent = true;
            break;          
        case PermissionObjectIds.PRODUCT_MANAGEMENT:
            info.Path = "/app/products"; 
            info.Indent = true;
            break;  
        case PermissionObjectIds.PRODUCT_PACKAGE:
            info.Path = "/app/productPackages"; 
            info.Indent = true;
            break;  
        case PermissionObjectIds.END_USER_LIST:
            info.Path = "/app/endUsers"; 
            info.Indent = true;
            break;          
        case PermissionObjectIds.DELIVERY_METHOD:
            info.Path = "/app/deliveryMethods"; 
            info.Indent = true;
            break;          
        case PermissionObjectIds.PAYMENT_TERM:
            info.Path = "/app/paymentTerms"; 
            info.Indent = true;
            break;          
        case PermissionObjectIds.PRINT_ENVELOP:
            info.Path = "/app/customerEnvelops"; 
            info.Indent = true;
            break;          
        case PermissionObjectIds.MANUFACTURER:
            info.Path = "/app/manufacturers"; 
            info.Indent = true;
            break;          
        case PermissionObjectIds.BOX_SIZE:
            info.Path = "/app/boxSizes"; 
            info.Indent = true;
            break;          
        case PermissionObjectIds.STAFF_MANAGEMENT:
            info.Path = "/app/staffs"; 
            info.Indent = true;
            break;          
        case PermissionObjectIds.STAFF_PERMISSION_MANAGEMENT:
            info.Path = "/app/staffPermissions"; 
            info.Indent = true;
            break;      
        case PermissionObjectIds.PERMISSION_MANAGEMENT:
            info.Path = "/app/permissions"; 
            info.Indent = true;
            break;      
        case PermissionObjectIds.TRADING_SALES_HISTORY:
            info.Path = "/app/purchaseorderHistory"; 
            info.Indent = true;
            break;      
        case PermissionObjectIds.TRADING_QUOTATION_HISTORY:
            info.Path = "/app/quotationHistory"; 
            info.Indent = true;
            break;      
        case PermissionObjectIds.PRODUCT_ENQUIRY:
            info.Path = "/app/invoiceHistory"; 
            info.Indent = true;
            break;      
        case PermissionObjectIds.FILING_RECORD_PO:
            info.Path = "/app/purchaseorderFilingRecord"; 
            info.Indent = true;
            break;      
        case PermissionObjectIds.FILING_RECORD_INVOICE:
            info.Path = "/app/invoiceFilingRecord"; 
            info.Indent = true;
            break;     
        case PermissionObjectIds.PO_ENQUIRY:
            info.Path = "/app/purchaseorderEnquiry"; 
            info.Indent = true;
            break;      
        case PermissionObjectIds.PURCHASE_RANKING:
            info.Path = "/app/purchaseorderRanking"; 
            info.Indent = true;
            break;      
        case PermissionObjectIds.REPORT_SALES_PO:
            info.Path = "/app/purchaseorderAnalysis"; 
            info.Indent = true;
            break;      
        case PermissionObjectIds.REPORT_SALES_ANALYSIS:
            info.Path = "/app/purchaseorderAnalysisSalesman"; 
            info.Indent = true;
            break;      
        case PermissionObjectIds.REPORT_SALES_SUMMARY:
            info.Path = "/app/purchaseorderSalesSummary"; 
            info.Indent = true;
            break;      
       }        
    return info;
}


export default SideBarItem;